module.exports = __webpack_public_path__ + "img/subscriptions.15b9f119.svg";